import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { useHistory } from 'react-router-dom'
import { Button } from '../../../../shard'
import { Size, Color } from '../../../../../const'

import { useTanakaIdHook } from 'hooks'

function TanakaIdConfirm() {
  const history = useHistory()
  const { successes, errors, isRequestingAPI, confirmTanakaId } = useTanakaIdHook()

  // マウント時のみ実行
  useEffect(() => {
    confirmTanakaId()
  }, [confirmTanakaId])

  if (isRequestingAPI) {
    return (
      <Wrapper>
        <TitleBlock>TANAKA-IDの存在確認中。</TitleBlock>
      </Wrapper>
    )
  } else {
    if (errors.length === 0) {
      return (
        <Wrapper>
          <TitleBlock>TANAKA-IDの存在確認完了</TitleBlock>
          <Message>
            {successes.join('\n')}
            <br />
            ご契約者の場合、マイページにログインし、NINALご契約のお客様は、決済情報を入力してください。
          </Message>
          <ButtonWrapper>
            <Button
              type={'submit'}
              primary
              onClick={() => {
                history.push('/login')
              }}
            >
              マイページ
            </Button>
          </ButtonWrapper>
        </Wrapper>
      )
    } else {
      return (
        <Wrapper>
          <TitleBlock>TANAKA-IDの存在確認失敗</TitleBlock>
          <Message>
            お客様のTANAKA-IDの存在確認が失敗しました。
            <br />
            {errors.join('\n')}
          </Message>
          <ButtonWrapper>
            <Button
              type={'submit'}
              primary
              onClick={() => {
                history.push('/login')
              }}
            >
              マイページ
            </Button>
          </ButtonWrapper>
        </Wrapper>
      )
    }
  }
}

const Wrapper = styled.div`
  padding: 30px 20px;
`

const TitleBlock = styled.div`
  color: ${Color.FONT.NORMAL};
  font-size: ${Size.FONT.HEADLINE.SMALL};
  padding: 40px 0px 20px 0px;
  border-bottom: 1px solid #ccc;
`

const Message = styled.div`
  padding: 10px 0;
  color: ${Color.FONT.ANNOTATION};
  padding-top: 30px;
`

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 100px;
`

TanakaIdConfirm.propTypes = {
  values: PropTypes.object,
  touched: PropTypes.object,
  errors: PropTypes.object,
  dirty: PropTypes.bool,
  isSubmitting: PropTypes.bool,
  handleChange: PropTypes.func,
  handleBlur: PropTypes.func,
  handleSubmit: PropTypes.func,
}

export default TanakaIdConfirm
